import { DropDownOption } from '../../shared/models/dropdown_option';
import { PLATFORM_TYPES } from '../../shared/services/constants/platform_types';

export const MAX_DISPLAY_NAME_LENGTH = 40;
export const MIN_PASSWORD_LENGTH = 8;
export const MIN_WEAK_PASSWORD_LENGTH = 6;
export const MAX_PASSWORD_LENGTH = 128;
export const STRONG_PASSWORD_PATTERN = '(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).*';
export const WEAK_PASSWORD_PATTERN = '.{6,}';
export const monthlyOrderOptions: DropDownOption<string>[] = [
    new DropDownOption<string>('0-50'),
    new DropDownOption<string>('50-200'),
    new DropDownOption<string>('200-500'),
    new DropDownOption<string>('500-1,000'),
    new DropDownOption<string>('1,000-5,000'),
    new DropDownOption<string>('5,000+')
];
export const platformOptions = PLATFORM_TYPES.map(p => new DropDownOption<string>(p.displayName, p.id));
export const DEFAULT_B2B_LOGIN_PAGE = '#/login';

